import React from 'react';

import { Styled } from './';
import { ServicePlanDetailsProps } from './ITeroProposal.types';
import { useI18n } from 'contexts/i18n';
import { useDoctorProfile } from 'reactQuery/queries';

const ServicePlanDetails = ({
  isMultipleScannerSubscriptions,
  currentProposal,
  servicePlanFee = 'N/A',
}: ServicePlanDetailsProps) => {
  const i18n = useI18n();
  const { data: doctor } = useDoctorProfile();

  return (
    <>
      <Styled.SummaryTitle>{i18n['Service Plan Details*']}</Styled.SummaryTitle>
      <Styled.ServicePlanSubText>
        {i18n['Applicable after the initial service term expiration.']}
      </Styled.ServicePlanSubText>
      <Styled.ProposalSubscription
        $isMultipleScannerSubscriptions={isMultipleScannerSubscriptions}
      >
        <Styled.Head>
          <Styled.HeaderCell>{i18n['Product']}</Styled.HeaderCell>
          {isMultipleScannerSubscriptions && (
            <Styled.HeaderCell>{i18n['Related Scanner']}</Styled.HeaderCell>
          )}
          <Styled.HeaderCell>{i18n['Quantity']}</Styled.HeaderCell>
          <Styled.HeaderCell>{i18n['List Price']}</Styled.HeaderCell>
          <Styled.HeaderCell>
            {i18n['Total Promotion/Discount Amount']}
          </Styled.HeaderCell>
          <Styled.HeaderCell>{i18n['Total Price']}</Styled.HeaderCell>
        </Styled.Head>
        <Styled.BodyRows>
          {currentProposal.lineitems.map(item => (
            <React.Fragment key={item.name}>
              {item.subscriptions?.map(subscription => (
                <React.Fragment key={subscription.name}>
                  <Styled.BodyCell>
                    <Styled.BodyCellContent>
                      {subscription.name}
                      {subscription.servicePlan && (
                        <Styled.SubOptions>
                          <strong>{i18n['Service Plan Fee Invoicing']}:</strong>{' '}
                          {subscription.servicePlan}
                        </Styled.SubOptions>
                      )}
                    </Styled.BodyCellContent>
                  </Styled.BodyCell>
                  {isMultipleScannerSubscriptions && (
                    <Styled.BodyCell>{item.name}</Styled.BodyCell>
                  )}
                  <Styled.BodyCell>{subscription.quantity}</Styled.BodyCell>
                  <Styled.BodyCell>
                    {subscription.displayItemUnitPrice}
                  </Styled.BodyCell>
                  <Styled.BodyCell>
                    {subscription.adjustmentAmount ? (
                      <div>{subscription.adjustmentAmount}</div>
                    ) : null}
                    {subscription.adjustmentAmount &&
                    subscription.promotionCode ? (
                      <div>{subscription.promotionCode}</div>
                    ) : null}

                    <Styled.HelperText>
                      {doctor?.country?.toUpperCase() === 'CA'
                        ? i18n['iTero Total Promotion Discount Table text - CA']
                        : i18n[
                            'iTero Total Promotion Discount Table text - US'
                          ]}
                    </Styled.HelperText>
                  </Styled.BodyCell>
                  <Styled.BodyCell>
                    {subscription.displayItemTotal}
                  </Styled.BodyCell>
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </Styled.BodyRows>
      </Styled.ProposalSubscription>
    </>
  );
};

export default ServicePlanDetails;
